import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}

.dashboard {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  background: #fff;
  color: #262334;
}

.course-composer {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  max-width: none;
  min-height: 100%;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
}

.composer-form {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: clamp(24px, 3vw, 48px);
  min-width: 0;
}

form {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.field:nth-child(2) {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.field:nth-child(2) textarea {
  flex: 1;
}

.form-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 36px;
}
.form-heading h1 {
  margin: 0 0 6px;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.6px;
}
.form-heading p {
  margin: 0;
  font-size: 12px;
  color: #8a8498;
  line-height: 1.6;
}

.form-icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: #fff0eb;
  color: #ff5b3b;
  font-size: 28px;
  font-weight: 300;
}

.field {
  margin-bottom: 24px;
}

.label-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

label {
  font-size: 13px;
  font-weight: 650;
}

.required-label {
  color: #ef5535;
  font-size: 10px;
  background: #fff0eb;
  padding: 2px 5px;
}

.optional-label {
  color: #a19aaa;
  font-size: 11px;
}

input, textarea {
  display: block;
  width: 100%;
  border: 1px solid #e7e3ec;
  border-radius: 0;
  background: #fcfbfd;
  padding: 14px 16px;
  color: #302a3d;
  font: inherit;
  font-size: 13px;
  line-height: 1.6;
  transition: border-color 150ms, box-shadow 150ms;
}
input::placeholder, textarea::placeholder {
  color: #aaa3b5;
}
input:focus, textarea:focus {
  outline: none;
  border-color: #ff967e;
  box-shadow: 0 0 0 3px #ffe7df;
}

textarea {
  resize: vertical;
  min-height: 112px;
}

.field-hint {
  color: #a19aaa;
  font-size: 11px;
  line-height: 1.6;
  margin: -8px 0 26px;
}

.add-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 0;
  border-radius: 0;
  padding: 15px 20px;
  background: #ff5b3b;
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms;
}
.add-button:hover:not(:disabled) {
  background: #e74c2d;
}
.add-button:focus-visible {
  outline: 3px solid #ff9d86;
  outline-offset: 3px;
}
.add-button:disabled {
  background: #eee5e2;
  color: #a89590;
  cursor: not-allowed;
}

.form-message {
  min-height: 20px;
  margin: 12px 0 0;
  color: #ff5b3b;
  font-size: 12px;
  line-height: 1.6;
}

@media (max-width: 800px) {
  .composer-form {
    padding: 24px 20px;
  }
  .form-heading {
    margin-bottom: 24px;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public courses: any[] = [];
    public newTitle = '';
    public newDescription = '';
    public message = '';
    public busy = false;
    constructor(@Inject( Service) public service: Service) {}
    private async pageRequest(action: string, data: any = {}) {
        const response: any = await wiz.app('component.page.share').call('handle', { action, data: JSON.stringify(data) });
        if (response.code !== 200) throw new Error(response.data?.message || response.message || '페이지를 불러오지 못했습니다.');
        return response.data;
    }

    async ngOnInit() {
        await this.service.init();
        if (this.service.auth.status) {
            try {
                const legacy = JSON.parse(localStorage.getItem('ku-dashboard-courses') || '[]');
                if (Array.isArray(legacy)) {
                    for (const course of legacy) {
                        if (!course?.title) continue;
                        const existing = await this.pageRequest('list');
                        if (!existing.owned.some((item: any) => item.title === course.title))
                            await this.pageRequest('create', {title: course.title, description: course.description || ''});
                    }
                    localStorage.removeItem('ku-dashboard-courses');
                }
                this.courses = (await this.pageRequest('list')).owned;
                window.dispatchEvent(new Event('ku-courses-changed'));
            } catch (error: any) { this.message = error.message; }
        }
        await this.service.render();
    }
    async addCourse() {
        if (this.busy) return;
        if (!this.service.auth.status) { this.message = '로그인 후 과목을 추가해주세요.'; await this.service.render(); return; }
        this.busy = true;
        try {
            const course = await this.pageRequest('create', {title: this.newTitle, description: this.newDescription});
            this.courses.push(course);
            window.dispatchEvent(new Event('ku-courses-changed'));
            this.newTitle = ''; this.newDescription = '';
            this.message = '왼쪽 메뉴에 과목을 추가했어요.';
        } catch (error: any) { this.message = error.message; }
        finally { this.busy = false; await this.service.render(); }
    }
}

export default PageDashboardComponent;